import React, { useState } from 'react';
import axios from 'axios';
import './Yad2ContactForm.css';

const Yad2ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone_number: '',
    car_type: '',
    message: '',
  });

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ 
      ...formData, 
      [e.target.name]: e.target.value 
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await axios.post('/api/contact-yad2', formData);
      if (response.data.success) {
        setSubmitted(true);
        setFormData({ name: '', phone_number: '', car_type: '', message: '' });
      }
    } catch (err) {
      console.error(err);
      setError('הייתה שגיאה בשליחת הטופס. נסה שוב מאוחר יותר.');
    }
  };

  return (
    <div className="Yad2ContactFormWrapper">
      {submitted && <p className="Yad2ContactFormSuccess">הטופס נשלח בהצלחה!</p>}
      {error && <p className="Yad2ContactFormError">{error}</p>}

      <div className="Yad2ContactFormFlexContainer">
        <div className="Yad2ContactFormHeader">
          <h1 className="Yad2ContactFormMainTitle">
            מחפשים מונית ספציפית?<br />תנו למומחים של קנה טקסי לחפש עבורכם!
          </h1>
<p className="Yad2ContactFormSubTitle">
  אנחנו לא עוד אתר מוניות – אנחנו המרכז שמחבר אותך ישירות לכל סוכנויות הרכב, המגרשים והנהגים בארץ.<br />
  עם גישה בזמן אמת למאות מוניות, קשרים אישיים עם בעלי מקצוע, וניסיון של שנים בשוק –<br />
  נוכל לאתר עבורך בדיוק את המונית שאתה מחפש – במהירות, ביעילות ובלי כאב ראש.<br />
  אתה רק ממלא את הפרטים – ואנחנו מתחילים לחפש בשבילך.
</p>
        </div>

        <form onSubmit={handleSubmit} className="Yad2ContactFormForm">
          <div className="Yad2ContactFormDivName">
            <label>שם:</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="Yad2ContactFormInputName"
            />
          </div>

          <div className="Yad2ContactFormDivPhone">
            <label>מספר טלפון:</label>
            <input
              type="text"
              name="phone_number"
              value={formData.phone_number}
              onChange={handleChange}
              required
              className="Yad2ContactFormInputPhone"
            />
          </div>

          <div className="Yad2ContactFormDivCarType">
            <label>סוג רכב:</label>
            <input
              type="text"
              name="car_type"
              value={formData.car_type}
              onChange={handleChange}
              className="Yad2ContactFormInputCarType"
            />
          </div>

          <div className="Yad2ContactFormDivMessage">
            <label>הודעה:</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              className="Yad2ContactFormTextareaMessage"
            ></textarea>
          </div>

          <button type="submit" className="Yad2ContactFormButton">שלח</button>
        </form>
      </div>
    </div>
  );
};

export default Yad2ContactForm;